/** Saving never publishes an existing draft. Publishing is an explicit action. */
export function publicationStateForSave({ existingId, active, paymentsReady }: {
  existingId?: string | null;
  active?: boolean;
  paymentsReady?: boolean | null;
}) {
  return existingId ? active === true : paymentsReady === true;
}
